import React from "react";

/**
 * Hero stat card with icon on the left so it stays fully visible (not cropped by decorative gradient).
 */
const HeroStat = ({ label, value, subLabel, icon, color = "theme-primary", trend }) => (
  <div className="bg-theme-secondary rounded-xl p-6 border border-theme-secondary relative overflow-hidden">
    <div className="flex items-start gap-4">
      <div
        className="w-14 h-14 flex-shrink-0 rounded-full flex items-center justify-center overflow-hidden"
        style={{ backgroundColor: `var(--color-${color})`, opacity: 0.2 }}
      >
        <div className={`text-${color} flex items-center justify-center w-full h-full [&>svg]:w-7 [&>svg]:h-7`}>{icon}</div>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-theme-text opacity-60 uppercase tracking-wider mb-2">
          {label}
        </p>
        <p className="text-3xl font-bold text-theme-text mb-1">{value}</p>
        {subLabel && (
          <p className="text-sm text-theme-text opacity-50">{subLabel}</p>
        )}
        {trend !== undefined && (
          <div className={`flex items-center gap-1 mt-2 text-sm font-medium ${trend >= 0 ? 'text-green-500' : 'text-red-500'}`}>
            {trend >= 0 ? (
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
              </svg>
            ) : (
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            )}
            <span>{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
    </div>
    {/* Decorative gradient - bottom-right, behind content */}
    <div className={`absolute -bottom-4 -right-4 w-24 h-24 rounded-full opacity-10 bg-${color} z-0 pointer-events-none`} />
  </div>
);

export default HeroStat;
